import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-4",
  style: {"font-size":"16px"}
}
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Mã y tế", -1)
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Tra cứu", -1)
const _hoisted_8 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-12 p-lg-2",
  style: {"font-size":"16px"}
}
const _hoisted_9 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Gởi", -1)
const _hoisted_12 = {
  class: "p-field p-col p-col-12 p-md-12 p-lg-12",
  style: {"font-size":"16px"}
}
const _hoisted_13 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_14 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Mã y tế", -1)
const _hoisted_16 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Họ và tên", -1)
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Ngày sinh", -1)
const _hoisted_20 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Giới tính", -1)
const _hoisted_22 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "CCCD/CMND", -1)
const _hoisted_24 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Số điện thoại", -1)
const _hoisted_26 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Địa chỉ thường trú", -1)
const _hoisted_28 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Chẩn đoán", -1)
const _hoisted_30 = { class: "p-field p-col p-col-12 p-md-12 p-lg-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Tên CLS", -1)
const _hoisted_32 = {
  key: 0,
  id: "id-note2",
  class: "p-error"
}
const _hoisted_33 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Thêm kết quả", -1)
const _hoisted_35 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-3 p-lg-2"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"16px"} }, "Gởi tập tin", -1)
const _hoisted_37 = { class: "p-field p-col-4 p-sm-4 p-md-3" }
const _hoisted_38 = { enctype: "multipart/form-data" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_41 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_42 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_43 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_44 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_45 = {
  key: 0,
  style: {"color":"blue"}
}
const _hoisted_46 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_47 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_48 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_49 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_50 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_51 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_52 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_53 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_54 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_55 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian thống kê: ", -1)
const _hoisted_57 = { class: "p-field p-col p-col-12 p-md-2 p-lg-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", null, "Xuất danh sách", -1)
const _hoisted_59 = { class: "p-field p-col p-col-12 p-md-3 p-lg-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", null, "Tải danh sách", -1)
const _hoisted_61 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_62 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_63 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_64 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_65 = { id: "loadingExport" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", null, "Hệ thống đang xử lý, vui lòng chờ trong giây lát...", -1)
const _hoisted_67 = { id: "sendingFile" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", null, "Hệ thống đang gởi dữ liệu, vui lòng chờ trong giây lát...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createBlock(_component_Accordion, { activeIndex: 0 }, {
    default: _withCtx(() => [
      _createVNode(_component_AccordionTab, { header: "Gởi kết quả CLS cho bệnh nhân" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Panel, { header: "Tra cứu thông tin CLS của bệnh nhân" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createVNode(_component_InputText, {
                        id: "name",
                        type: "text",
                        modelValue: $setup.maYTe,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.maYTe) = $event)),
                        style: {"text-align":"center","font-size":"16px"},
                        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => ($setup.loadListCls()), ["enter"]))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_component_Button, {
                        label: "Tìm",
                        icon: "pi pi-plus-circle",
                        iconPos: "left",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadListCls())),
                        style: {"font-size":"16px"}
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            ($setup.listIdCls.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_Panel, { header: "Gởi kết quả cho bệnh nhân" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createVNode(_component_Button, {
                            label: "Gởi kết quả",
                            icon: "pi pi-send",
                            iconPos: "left",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.sendClsForCustomer())),
                            severity: "warning",
                            style: {"font-size":"16px"}
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              ($setup.listCLS.length > 0)
                ? (_openBlock(), _createBlock(_component_Panel, {
                    key: 0,
                    header: "Thông tin bệnh nhân"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createVNode(_component_InputText, {
                            id: "maYTe",
                            type: "text",
                            modelValue: $setup.listCLS[0].mayte,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.listCLS[0].mayte) = $event)),
                            style: {"text-align":"center","font-size":"16px"},
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _hoisted_17,
                          _createVNode(_component_InputText, {
                            id: "hoVaTen",
                            type: "text",
                            modelValue: $setup.listCLS[0].tenbenhnhan,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.listCLS[0].tenbenhnhan) = $event)),
                            style: {"text-align":"center","font-size":"16px"},
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createVNode(_component_InputText, {
                            id: "ngaySinh",
                            modelValue: $setup.ngaySinh,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.ngaySinh) = $event)),
                            type: "text",
                            style: {"text-align":"center","font-size":"16px"},
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createVNode(_component_InputText, {
                            id: "gioiTinh",
                            type: "text",
                            modelValue: $setup.listCLS[0].gioitinh,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.listCLS[0].gioitinh) = $event)),
                            style: {"text-align":"center","font-size":"16px"},
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode(_component_InputText, {
                            id: "cmnd",
                            type: "text",
                            modelValue: $setup.listCLS[0].cmnd,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.listCLS[0].cmnd) = $event)),
                            style: {"text-align":"center","font-size":"16px"},
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createVNode(_component_InputText, {
                            id: "dt",
                            type: "text",
                            modelValue: $setup.listCLS[0].sodienthoai,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.listCLS[0].sodienthoai) = $event)),
                            style: {"text-align":"center","font-size":"16px"},
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createVNode(_component_InputText, {
                            id: "diaChi",
                            type: "text",
                            modelValue: $setup.listCLS[0].diachithuongtru,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.listCLS[0].diachithuongtru) = $event)),
                            style: {"text-align":"center","font-size":"16px"},
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _hoisted_29,
                          _createVNode(_component_InputText, {
                            id: "chanDoan",
                            type: "text",
                            modelValue: $setup.listCLS[0].chandoan,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.listCLS[0].chandoan) = $event)),
                            style: {"text-align":"center","font-size":"16px"},
                            disabled: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createVNode(_component_InputText, {
                            id: "loaiCLS",
                            type: "text",
                            modelValue: $setup.cls.kind,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.cls.kind) = $event)),
                            style: {"text-align":"center","font-size":"16px"}
                          }, null, 8, ["modelValue"]),
                          ($setup.cls.kind == null)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_32, "* Vui lòng cung cấp tên CLS thực hiện cho bệnh nhân"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createVNode(_component_Button, {
                            class: "p-button-outlined",
                            label: "Thêm kết quả CLS",
                            onclick: "document.getElementById('myFile').click()",
                            icon: "pi pi-paperclip"
                          })
                        ]),
                        (($setup.listFileName.length > 0)&&($setup.cls.kind != null))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _hoisted_36,
                              _createVNode(_component_Button, {
                                label: "Thêm dữ liệu",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.upload())),
                                icon: "pi pi-send",
                                style: {"margin-right":"5vw"},
                                severity: "warning"
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("form", _hoisted_38, [
                            _createElementVNode("input", {
                              id: "myFile",
                              type: "file",
                              style: {"display":"none"},
                              accept: ".pdf",
                              name: "files",
                              onChange: _cache[14] || (_cache[14] = ($event: any) => ($setup.fileChange($event.target.files))),
                              disabled: $setup.loadingBar
                            }, null, 40, _hoisted_39)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_40, [
              (!$setup.permissionCLS)
                ? (_openBlock(), _createBlock(_component_Panel, {
                    key: 0,
                    header: "Dữ liệu kết quả CLS"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_DataTable, {
                            loading: _ctx.isLoading,
                            value: $setup.listFileCls,
                            paginator: true,
                            stripedRows: "",
                            rows: 30,
                            rowsPerPageOptions: [30,50,100],
                            rowHover: true,
                            filters: $setup.filters,
                            "onUpdate:filters": _cache[18] || (_cache[18] = ($event: any) => (($setup.filters) = $event)),
                            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                            globalFilterFields: ['tendichvu'],
                            currentPageReportTemplate: "Có tổng số {totalRecords} dữ liệu kết quả   CLS",
                            columnResizeMode: "fit | expand"
                          }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", _hoisted_43, [
                                _createVNode(_component_Button, {
                                  type: "button",
                                  icon: "pi pi-filter-slash",
                                  label: "Xoá",
                                  class: "p-button-outlined",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.clearFilter())),
                                  style: {"width":"6em"}
                                }),
                                _createElementVNode("span", _hoisted_44, [
                                  _createVNode(_component_InputText, {
                                    modelValue: $setup.filters['global'].value,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.filters['global'].value) = $event)),
                                    placeholder: "Tìm theo dịch vụ"
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                field: "fullName",
                                header: "Tên tài khoản gởi",
                                sortable: ""
                              }),
                              _createVNode(_component_Column, {
                                field: "time",
                                header: "Thời gian gởi",
                                sortable: ""
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.time)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "path",
                                header: "Tên tập tin",
                                sortable: ""
                              }),
                              _createVNode(_component_Column, {
                                field: "kind",
                                header: "Tên dịch vụ CLS",
                                sortable: ""
                              }),
                              _createVNode(_component_Column, {
                                field: "trangThai",
                                header: "Tình trạng",
                                sortable: ""
                              }, {
                                body: _withCtx((slotProps) => [
                                  (slotProps.data.trangThai)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_45, "ĐÃ GỞI"))
                                    : (_openBlock(), _createElementBlock("label", _hoisted_46, "CHƯA GỞI"))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "trangThai",
                                header: "Chọn dịch vụ",
                                sortable: ""
                              }, {
                                body: _withCtx((slotProps) => [
                                  _createVNode(_component_Checkbox, {
                                    modelValue: $setup.listIdCls,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.listIdCls) = $event)),
                                    value: slotProps.data.id,
                                    onChange: $setup.selectCheckBox
                                  }, null, 8, ["modelValue", "value", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["loading", "value", "filters"])
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_Panel, { header: "Danh sách dịch vụ CLS" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_DataTable, {
                        loading: _ctx.isLoading,
                        value: $setup.listCLS,
                        paginator: true,
                        stripedRows: "",
                        rows: 30,
                        rowsPerPageOptions: [30,50,100],
                        rowHover: true,
                        filters: $setup.filters,
                        "onUpdate:filters": _cache[21] || (_cache[21] = ($event: any) => (($setup.filters) = $event)),
                        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                        globalFilterFields: ['tendichvu'],
                        currentPageReportTemplate: "Có tổng số {totalRecords} dịch vụ CLS",
                        columnResizeMode: "fit | expand"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_50, [
                            _createVNode(_component_Button, {
                              type: "button",
                              icon: "pi pi-filter-slash",
                              label: "Xoá",
                              class: "p-button-outlined",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.clearFilter())),
                              style: {"width":"6em"}
                            }),
                            _createElementVNode("span", _hoisted_51, [
                              _createVNode(_component_InputText, {
                                modelValue: $setup.filters['global'].value,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.filters['global'].value) = $event)),
                                placeholder: "Tìm theo dịch vụ"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            field: "tendichvu",
                            header: "Tên dịch vụ",
                            sortable: ""
                          }),
                          _createVNode(_component_Column, {
                            field: "ngaygioyeucau",
                            header: "Thời gian yêu cầu",
                            sortable: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.ngaygioyeucau)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["loading", "value", "filters"])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_AccordionTab, { header: "Thống kê gởi kết quả CLS" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_Panel, { header: "Dữ liệu gởi kết quả CLS" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createVNode(_component_Calendar, {
                        id: "date",
                        modelValue: $setup.date,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.date) = $event)),
                        selectionMode: "range",
                        dateFormat: "dd/mm/yy",
                        showButtonBar: true,
                        showIcon: true,
                        manualInput: false,
                        monthNavigator: true,
                        yearNavigator: true,
                        yearRange: "2000:2100",
                        onDateSelect: _cache[23] || (_cache[23] = ($event: any) => ($setup.selectCalendar())),
                        onClearClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.clearCalendar()))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createVNode(_component_Button, {
                        label: "Xử lý",
                        icon: "pi pi-spinner",
                        iconPos: "left",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.exportFile())),
                        disabled: $setup.listClsSent.length < 1
                      }, null, 8, ["disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _hoisted_60,
                      _createVNode(_component_Button, {
                        label: "Tải",
                        icon: "pi pi-download",
                        severity: "warning",
                        iconPos: "left",
                        onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.downLoadFileExport($setup.fileName))),
                        disabled: !$setup.downloadFile
                      }, null, 8, ["disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createVNode(_component_DataTable, {
                        loading: _ctx.isLoading,
                        value: $setup.listClsSent,
                        paginator: true,
                        stripedRows: "",
                        rows: 30,
                        rowsPerPageOptions: [30,50,100],
                        rowHover: true,
                        filters: $setup.filters,
                        "onUpdate:filters": _cache[29] || (_cache[29] = ($event: any) => (($setup.filters) = $event)),
                        paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                        globalFilterFields: ['patientsName'],
                        currentPageReportTemplate: "Có tổng số {totalRecords} dữ liệu trả kết quả CLS",
                        columnResizeMode: "fit | expand"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_Button, {
                              type: "button",
                              icon: "pi pi-filter-slash",
                              label: "Xoá",
                              class: "p-button-outlined",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.clearFilter())),
                              style: {"width":"6em"}
                            }),
                            _createElementVNode("span", _hoisted_63, [
                              _createVNode(_component_InputText, {
                                modelValue: $setup.filters['global'].value,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.filters['global'].value) = $event)),
                                placeholder: "Tìm theo dịch vụ"
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_Column, {
                            header: "Stt",
                            headerStyle: "width:3rem"
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "patientsName",
                            header: "Tên bệnh nhân",
                            sortable: ""
                          }),
                          _createVNode(_component_Column, {
                            field: "maYTe",
                            header: "Mã y tế",
                            sortable: ""
                          }),
                          _createVNode(_component_Column, {
                            field: "phoneNumber",
                            header: "Số điện thoại",
                            sortable: ""
                          }),
                          _createVNode(_component_Column, {
                            field: "time",
                            header: "Thời gian gởi",
                            sortable: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              _createTextVNode(_toDisplayString($setup.formatDateTime(slotProps.data.time)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Column, {
                            field: "kind",
                            header: "Tên dịch vụ CLS",
                            sortable: ""
                          }),
                          _createVNode(_component_Column, {
                            field: "path",
                            header: "Tên tập tin",
                            sortable: ""
                          }),
                          _createVNode(_component_Column, {
                            field: "success",
                            header: "Trạng thái",
                            sortable: ""
                          }, {
                            body: _withCtx((slotProps) => [
                              (slotProps.data.success)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    severity: "info",
                                    label: "GỞI THÀNH CÔNG",
                                    type: "button"
                                  }))
                                : (_openBlock(), _createBlock(_component_Button, {
                                    key: 1,
                                    severity: "warning",
                                    label: "GỞI LỖI",
                                    type: "button"
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["loading", "value", "filters"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createVNode(_component_Dialog, {
                header: "Đang xử lý",
                visible: $setup.loadingData,
                "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => (($setup.loadingData) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_65, [
                    _hoisted_66,
                    _createVNode(_component_ProgressBar, {
                      mode: "indeterminate",
                      style: {"height":".3em"}
                    })
                  ])
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_Dialog, {
                header: "Đang gởi dữ liệu",
                visible: $setup.sendingData,
                "onUpdate:visible": _cache[31] || (_cache[31] = ($event: any) => (($setup.sendingData) = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode(_component_ProgressBar, {
                      mode: "indeterminate",
                      style: {"height":".3em"}
                    })
                  ])
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_ConfirmDialog)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}